<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>{{ 'communication.chat.editMemberExpirationTime' | t }}</h2>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
    <button [disabled]="form.invalid" mat-button type="submit" color="success">{{ 'common.save' | t }}</button>
  </mat-dialog-actions>
</form>
